import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form", 
    "slider", 
    "sliderValue", 
    "success", 
    "successName", 
    "successCompany",
    "successPotential",
    "successEstimatedValue"
  ]
  static values = {
    currencyFormat: { type: String, default: "en-US" }
  }

  connect() {
    this.updateSliderValue()
  }

  updateSliderValue() {
    const value = this.sliderTarget.value
    const formatted = new Intl.NumberFormat(this.currencyFormatValue, {
      style: 'currency',
      currency: 'CAD',
      maximumFractionDigits: 0
    }).format(value)
    
    this.sliderValueTarget.textContent = formatted
  }

  async submit(event) {
    event.preventDefault()

    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        body: new FormData(this.formTarget)
      })

      const data = await response.json()
      console.log('Response:', { status: response.status, data })
      
      if (response.ok) {
        // Update success modal content
        this.successNameTarget.textContent = data.lead.contact_name
        this.successCompanyTarget.textContent = data.lead.name
        
        const amount = parseFloat(data.lead.lead_value || 0)
        const commission = parseFloat(data.lead.commission || 0)
        
        console.log('Values:', { amount, commission })

        // Convert to K format (divide by 1000)
        const amountK = (amount / 1000).toFixed(1)
        const commissionK = (commission / 1000).toFixed(1)

        this.successPotentialTarget.textContent = 
          this.successPotentialTarget.dataset.i18n
            ?.replace('%{commission}', commissionK) || 'Potential'
            
        this.successEstimatedValueTarget.textContent = 
          this.successEstimatedValueTarget.dataset.i18n
            ?.replace('%{amount}', amountK) || ''

        // Show success modal using DaisyUI modal
        this.successTarget.showModal()

        // Store redirect URL for later use
        this.redirectUrl = data.redirect_url
      } else {
        // Show error using DaisyUI toast
        const toast = document.createElement('div')
        toast.className = 'toast toast-top toast-end'
        toast.innerHTML = `
          <div class="alert alert-error">
            <span>${Array.isArray(data.error) ? data.error.join(', ') : data.error || 'An error occurred'}</span>
          </div>
        `
        document.body.appendChild(toast)
        setTimeout(() => toast.remove(), 3000)
      }
    } catch (error) {
      console.error('Error submitting lead:', error)
      // Show error using DaisyUI toast
      const toast = document.createElement('div')
      toast.className = 'toast toast-top toast-end'
      toast.innerHTML = `
        <div class="alert alert-error">
          <span>An error occurred while submitting your lead. Please try again.</span>
        </div>
      `
      document.body.appendChild(toast)
      setTimeout(() => toast.remove(), 3000)
    }
  }

  closeSuccess() {
    this.successTarget.close()
    window.location.href = this.redirectUrl || this.data.get("redirectUrl")
  }
}
